export default __webpack_public_path__ + "static/media/bgBlurAppScreen.afc6ba8a.png";